import classNames from 'classnames';
import { useEffect, useState } from 'react';

import http from '@/utils/http';

type Status = 'checking' | 'up' | 'down';

const LABELS: Record<Status, string> = {
  checking: 'Checking API…',
  up: 'API connected',
  down: 'API unreachable',
};

/** Shows whether the backend answers /ruok. */
const ApiStatus = () => {
  const [status, setStatus] = useState<Status>('checking');

  useEffect(() => {
    let cancelled = false;
    http
      .get('/ruok')
      .then(() => !cancelled && setStatus('up'))
      .catch(() => !cancelled && setStatus('down'));
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex items-center gap-2 text-xs text-fg-faint">
      <span
        className={classNames('h-2 w-2 rounded-pill', {
          'bg-fg-faint': status === 'checking',
          'bg-ok': status === 'up',
          'bg-danger': status === 'down',
        })}
      />
      {LABELS[status]}
    </div>
  );
};

export default ApiStatus;
